import { type GetColorDefinition } from 'atoms/colors/colors';

// Quarks
import Container from 'quarks/Container';
import Flex from 'quarks/Flex';
import Image, { ImageData } from 'quarks/Image';
import type { FlexProps } from 'quarks/interpolations/flex';

import ComponentHeading from 'components/Heading/Heading';

// Scripts
import { getBackgroundColor } from 'utils/functions';

// Types
import type { ContentfulComponentConversionPanel } from 'graphqlTypes';
import type { FC } from 'react';

interface ConversionPanelProps extends FlexProps, ContentfulComponentConversionPanel {
  backgroundIsDark: boolean;
  convHeading?: ContentfulComponentConversionPanel['heading'];
  color?: string;
}

const ComponentConversionPanel: FC<ConversionPanelProps> = ({
  convHeading,
  backgroundIsDark,
  backgroundAccent,
  offsetTopColor,
  offsetBottomColor,
  color,
  ...props
}) => (
  <>
    <Flex
      position="relative"
      flexDirection="column"
      width="100%"
      borderRadius="24px"
      paddingY={40}
      paddingX={16}
      md={{ paddingY: 64, paddingX: 40 }}
      lg={{ paddingY: 96 }}
      backgroundColor={getBackgroundColor(color || 'Green 300')}
      {...props}
    >
      {convHeading && <ComponentHeading zIndex={2} backgroundIsDark={backgroundIsDark} {...convHeading} />}
      {backgroundAccent && (
        <Container position="absolute" bottom="0" left="0" display="none" md={{ display: 'block' }}>
          <Image
            image={backgroundAccent as ImageData}
            alt={backgroundAccent?.title || 'Section Background'}
            width="100%"
            height="100%"
          />
        </Container>
      )}
    </Flex>
    {offsetTopColor && (
      <Flex
        position="absolute"
        width="100%"
        height="50%"
        top="0"
        left="0"
        zIndex="-1"
        backgroundColor={getBackgroundColor(offsetTopColor || 'White') as GetColorDefinition}
      />
    )}
    {offsetBottomColor && (
      <Flex
        position="absolute"
        width="100%"
        height="50%"
        left="0"
        bottom="0"
        zIndex="-1"
        backgroundColor={getBackgroundColor(offsetBottomColor || 'White') as GetColorDefinition}
      />
    )}
  </>
);

export default ComponentConversionPanel;
